type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

type EndpointHeaderProps = {
  method: HttpMethod;
  path: string;
};

/** An API endpoint line ("POST /images/generate") as a glass strip. */
export function EndpointHeader({ method, path }: EndpointHeaderProps) {
  return (
    <div className="g-glass g-round-sm my-6 flex items-center gap-3 overflow-x-auto px-4 py-3">
      <span className="flex-none rounded-full border border-(--g-rule) px-2.5 py-[5px] font-mono text-[11.5px] leading-none font-medium text-(--g-ink)">
        {method}
      </span>
      <span className="font-mono text-[14px] whitespace-nowrap text-(--g-ink)">
        {path}
      </span>
    </div>
  );
}
